import { memo } from "react"
import { Facebook, Instagram, LinkedIn, PhoneEnabled, Telegram, Twitter } from "@mui/icons-material"
import { Grid, Typography } from "@mui/material"
import Link from "next/link"

const mapItemToIcon = item => {
  switch (item) {
    case "instagram":
      return <Instagram sx={{ color: mapItemToColor(item) }} />
    case "facebook":
      return <Facebook sx={{ color: mapItemToColor(item) }} />
    case "twitter":
      return <Twitter sx={{ color: mapItemToColor(item) }} />
    case "telegram":
      return <Telegram sx={{ color: mapItemToColor(item) }} />
    case "linkedIn":
      return <LinkedIn sx={{ color: mapItemToColor(item) }} />

    default:
      return <PhoneEnabled />
  }
}

const mapItemToColor = item => {
  switch (item) {
    case "instagram":
      return "#d53946"
    case "facebook":
      return "#395498"
    case "twitter":
      return "#1C96E8"
    case "telegram":
      return "#1C96E8"
    case "linkedIn":
      return "#007AB5"
  }
}

const CustomIconWithText = ({ data }) => {
  const merchantData = Object.keys(data)
    .filter(
      x =>
        x !== "name" &&
        x !== "siteAddress" &&
        x !== "storeType" &&
        x !== "classOfActivity" &&
        x !== "logo" &&
        x !== "branches"
    )
    .map(key => [key, data[key]])
  return (
    // <Row className={props.grid}>
    <Grid container justifyContent='center'>
      {merchantData.map((item, i) => {
        return item[1] ? (
          <Grid item xs={4} sm={6} md={1.2} key={i} marginTop={4}>
            <Link href={item[0].includes("phoneNumber") ? `tel:${item[1]}` : item[1]} target='_blank'>
              <div key={i} className='custom-icon-with-text02'>
                <div className='feature-box-icon'>
                  {mapItemToIcon(item[0])}
                  <span className='feature-box-svg-shap drop-shadow'>
                    <svg width='100' viewBox='-100 -100 200 200' xmlns='http://www.w3.org/2000/svg'>
                      <path
                        fill='#f7f7f7'
                        d='M86.2,51.4C58.6,97.5,-53.4,96.5,-81.8,49.9C-110.3,3.3,-55.1,-88.8,0.9,-88.3C56.9,-87.8,113.7,5.3,86.2,51.4Z'
                      ></path>
                    </svg>
                  </span>
                </div>

                {item[0].includes("phoneNumber") ? (
                  <div className='feature-box-content'>
                    <Typography variant='h5'>{item[1]}</Typography>
                  </div>
                ) : null}
              </div>
            </Link>
          </Grid>
        ) : null
      })}
    </Grid>
  )
}

export default memo(CustomIconWithText)
